import { Avatar, AvatarI } from 'components/Avatar/Avatar';
import { Box } from 'components/Box';
import { Flex } from 'components/Flex';
import { P } from 'components/Typography/Typography';
import React from 'react';
import { getUserDisplayLines, UserDisplayFields } from 'utilities/fullName';

export interface UserAvatarRowProps extends UserDisplayFields {
  /** Ścieżka względna (`/uploads/...`), pełny URL albo brak — wtedy widać domyślną ikonę. */
  photo?: string | null;
  avatarSize?: AvatarI['size'];
}

const buildPhotoUrl = (photo?: string | null) => {
  if (!photo) return undefined;
  if (photo.startsWith('http') || photo.startsWith('blob:')) return photo;
  return `${process.env.REACT_APP_API_URL}${photo}`;
};

/**
 * Poziomy wiersz: avatar użytkownika + imię/nazwisko (lub email) z opcjonalnym emailem pod spodem.
 *
 * Avatar korzysta z {@link Avatar}: zawsze renderuje domyślną ikonę sylwetki; gdy `photo` jest
 * podane, miniatury profilowe nakładane są jako `background-image` nad tą ikoną.
 */
export const UserAvatarRow: React.FC<UserAvatarRowProps> = ({
  photo,
  avatarSize = 'extra-small',
  profile,
  first_name,
  last_name,
  email,
  username
}) => {
  const { primary, secondary } = getUserDisplayLines({
    profile,
    first_name,
    last_name,
    email,
    username
  });

  if (!primary) return null;

  return (
    <Flex alignItems="center">
      <Box mr={2} flexShrink={0}>
        <Avatar size={avatarSize} url={buildPhotoUrl(photo)} />
      </Box>
      <Flex flexDirection="column" minWidth={0}>
        <P variant="body">{primary}</P>
        {secondary && (
          <P variant="body2" color="secondary">
            {secondary}
          </P>
        )}
      </Flex>
    </Flex>
  );
};
